<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2020-07-07 11:43:10
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-06 14:12:20
-->
<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <div>
        <keep-alive :include="cachedViews">
          <router-view v-if="$route.meta.keepAlive !== false" :key="key" />
        </keep-alive>
        <router-view v-if="$route.meta.keepAlive === false" :key="key" />
      </div>
      <!-- <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive> -->
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    }
  }
}
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  min-height: calc(100vh - 84px);
  width: 100%;
  position: relative;
  overflow: hidden;
  padding: 20px;
}
.content {
  padding: 20px;
}
</style>
